import axios from "axios";


const API = axios.create({

    baseURL: `${process.env.REACT_APP_BACKEND_URI}/api`

});



// ==========================
// Get All Departments
// ==========================

export const getDepartments = async () => {

    const response = await API.get(
        "/departments/"
    );

    return response.data;

};




// ==========================
// Get Department By ID
// ==========================

export const getDepartment = async (
    departmentId
) => {

    const response = await API.get(
        `/departments/${departmentId}`
    );

    return response.data;

};




// ==========================
// Create Department
// ==========================

export const createDepartment = async (
    departmentData
) => {

    const response = await API.post(
        "/departments/",
        departmentData
    );

    return response.data;

};




// ==========================
// Update Department
// ==========================

export const updateDepartment = async (

    departmentId,

    departmentData

) => {

    const response = await API.put(

        `/departments/${departmentId}`,

        departmentData

    );


    return response.data;

};




// ==========================
// Delete Department
// ==========================

export const deleteDepartment = async (

    departmentId,

    deleteRelated = false

) => {

    const response = await API.delete(

        `/departments/${departmentId}`,

        {

            params:{

                delete_related: deleteRelated

            }

        }

    );


    return response.data;

};



export default API;